// Shared JSC team data.
export const CORE = [
  { img: "/assets/jay-shah.jpg", name: "Jay Shah", role: "CEO & Founder", alt: "Jay Shah, CEO and Founder of Jay Shah Consultancy" },
  { img: "/assets/naveen-george.jpg", name: "Naveen Phillipose George", role: "CSO", alt: "Naveen Phillipose George, CSO of Jay Shah Consultancy" },
  { img: "/assets/aashish-bhole.jpg", name: "Aashish Bhole", role: "CTO", alt: "Aashish Bhole, CTO of Jay Shah Consultancy" },
  { img: "/assets/prithviraj-mishra.jpg", name: "Prithviraj Mishra", role: "CMO", alt: "Prithviraj Mishra, CMO of Jay Shah Consultancy" },
];

export const MEMBERS = [
  { initials: "KA", name: "Kajal Agarwal", role: "Senior Business Analyst" },
  { initials: "SD", name: "Shlok Dewarkar", role: "Business Analyst" },
];
